// ============================================================
// ANSICHTSSACHE-AGENT – Zustand der Oberflaeche
// ============================================================
// Bislang lag hier ein `sidebarCollapsed`, das nie jemand gelesen
// hat. Jetzt haengt die Seitenleiste wirklich daran — und der
// Zustand ueberlebt den Seitenwechsel, weil sonst jede Navigation
// die eingeklappte Leiste wieder aufklappen wuerde.
//
// Dazu kam der Hinweis auf die Installation als App. Er gehoert
// aus demselben Grund hierher: ein weggeklickter Hinweis, der
// beim naechsten Seitenwechsel wieder dasteht, ist kein Angebot,
// sondern eine Belaestigung.
// ============================================================

import { create } from "zustand";
import { persist } from "zustand/middleware";

interface UIState {
  leisteEingeklappt: boolean;
  leisteUmschalten: () => void;
  /** Einmal weggeklickt, kommt er nicht wieder — der Weg bleibt „Mein Konto -> App“. */
  installationshinweisGesehen: boolean;
  installationshinweisSchliessen: () => void;
  /**
   * Dasselbe fuer das Angebot, Meldungen zu erlauben. Es kommt im
   * installierten Fenster und, einmal beantwortet oder
   * weggeklickt, nicht wieder — erlaubt wird danach unter „Mein
   * Konto -> Benachrichtigungen“.
   */
  pushPromptDismissed: boolean;
  dismissPushPrompt: () => void;
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      leisteEingeklappt: false,
      leisteUmschalten: () => set((s) => ({ leisteEingeklappt: !s.leisteEingeklappt })),
      installationshinweisGesehen: false,
      installationshinweisSchliessen: () => set({ installationshinweisGesehen: true }),
      pushPromptDismissed: false,
      dismissPushPrompt: () => set({ pushPromptDismissed: true }),
    }),
    { name: "agent-oberflaeche" },
  ),
);
